import angular from 'angular';

(function () {
  'use strict';

  angular.module('app.principal').controller('ReferentialReducedSectionCtrl', ReferentialReducedSectionCtrl);

  ReferentialReducedSectionCtrl.$inject = ['AuthSvc'];

  function ReferentialReducedSectionCtrl(AuthSvc) {

    this.isEditAuthorized = AuthSvc.isAuthorized('CONFIGURATOR');
    var vm = this;

    ////////////////////////

    vm.$onInit = function () {
      vm.collapseTable = true;
    };
  }
})();
